import { useQuery } from 'hooks/useCustomQuery';
import getCarrier from 'API/Carriers/getCarrier';

const useGetCarrier = (carrierId, enabled = true) => {
    return useQuery({
        queryKey: ['Carrier', carrierId],
        queryFn: async () => {
            const response = await getCarrier(carrierId);
            return response.data;
        },
        enabled: enabled && !!carrierId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetCarrier;
